const styles = {
    top: {
        textAlign: 'left',
    },

    animationButton: {
        display: 'block',
    },

    buttonGroup: {
        display: 'inline-block',
        marginLeft: '30px',
        textAlign: 'center',
    },

    container: {
        padding: '20px 30px',
    },

    disabled: {
        opacity: 0.3,
    },

    ficusControlsHeader: {
        textAlign: 'left',
        marginTop: '30px',
        marginLeft: '20px',
    },

    ficusControlsHeaderTitle: {
        color: '#D9782D',
        fontWeight: 'bold',
    },

    label: {
        width: '200px',
    },

    radioHelpLabel: {
        fontSize: 'smaller',
    },

    span: {
        display: 'inline-block',
        textAlign: 'left',
        height: '40px',
        verticalAlign: 'middle',
    },

    speedContainer: {
        marginTop: '20px',
        marginLeft: '30px',
    },

    speedLabel: {
        marginLeft: '10px',
        textAlign: 'left',
        width: '60px',
        display: 'inline-block',
    },

    frameLabel: {
        float: 'right',
        marginRight: '20px',
    },

    radioContainer: {
    },

    slider: {
        fontSize: '14px',
    },

    sliderContainer: {
        padding: '0px 20px 40px 30px',
    },

    missingData: {
        textAlign: 'center',
        marginTop: '30px',
        width: '100%',
    },

    missingImage: {
        width: '25%',
    },
}

export default styles
